import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, PenTool, GitMerge } from 'lucide-react';
const pillars = [{
  num: '01',
  icon: <Cpu size={32} className="text-blue-500" data-id="element-184" />,
  title: 'High-Performance Architecture',
  description: 'Faster, safer, conversion-optimized. We build on modern stacks where every millisecond is engineered for revenue.'
}, {
  num: '02',
  icon: <PenTool size={32} className="text-blue-500" data-id="element-185" />,
  title: 'Premium Content Studio',
  description: 'Content that positions you as the authority, not a follower. Strategy-first storytelling that commands premium pricing.'
}, {
  num: '03',
  icon: <GitMerge size={32} className="text-blue-500" data-id="element-186" />,
  title: 'The Synergy',
  description: 'The bridge between how you look and what you say. Architecture meets narrative to create an undeniable digital asset.'
}];
export function FrameworkSection() {
  return <section id="framework" className="py-24 md:py-32 bg-[#0A0A0A] relative" data-id="element-187">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-188" />

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-20" data-id="element-190">
          <span className="text-blue-500 font-medium tracking-widest text-sm uppercase mb-4 block" data-id="element-191">
            The Solution
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-192">
            The PCS Framework
          </h2>
          <p className="text-xl text-neutral-400 max-w-2xl mx-auto" data-id="element-193">
            We don't just design pages. We architect systems that elevate your
            brand's perceived value and drive measurable ROI.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-194">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-px bg-white/5" data-id="element-195" />

          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center group" data-id="element-196">
              <div className="w-24 h-24 bg-[#111111] border border-white/10 rounded-full flex items-center justify-center mb-8 relative z-10 group-hover:border-blue-500/50 transition-colors" data-id="element-197">
                {pillar.icon}
                <span className="absolute -top-2 -right-2 text-4xl font-display font-bold text-white/5 select-none" data-id="element-198">
                  {pillar.num}
                </span>
              </div>

              <h3 className="font-display text-2xl font-semibold text-white mb-4" data-id="element-199">
                {pillar.title}
              </h3>
              <p className="text-neutral-400 leading-relaxed max-w-sm" data-id="element-200">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}